<div id = 'pwcontainer' class="pwcontainer">
  <h1 class="ctr">Please Wait...</h1>
  <div class="pwfillme">
    <div class="pwfillme-line">
    </div>
  </div>
</div>